import { Component, Input, Output, EventEmitter, OnInit, inject, Inject } from '@angular/core';
import { PartyBeneficiariesService, PartyBeneficiary } from '@nano/common/party-beneficiaries';
import { CONFIG } from '@nano/core/config';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { NzOptionSelectionChange } from 'ng-zorro-antd/auto-complete';
import { Observable, of, ReplaySubject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, shareReplay, startWith, switchMap } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
import { ErrorService } from '@nano/core/error';

@Component({
  selector: 'app-beneficiary-name-input',
  templateUrl: './beneficiary-name-input.component.html',
  standalone: false
})
export class BeneficiaryNameInputComponent implements OnInit {
  private config = inject(CONFIG);
  private beneficiaryNameInput$ = new ReplaySubject<string>(1);
  @Input() beneficiaryNameMinLength: number;
  @Input() beneficiaryNameMaxLength: number;
  @Input() nzExtra: string | null = null;
  @Input() beneficiaryNameControl: AbstractControl;
  @Output() beneficiarySelected = new EventEmitter<PartyBeneficiary>();

  beneficiaries$: Observable<PartyBeneficiary[]>;
  selectedBeneficiary: PartyBeneficiary;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private beneficiariesService: PartyBeneficiariesService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.beneficiaries$ = this.beneficiaryNameInput$.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : '')),
      debounceTime(150),
      distinctUntilChanged(),
      switchMap((value) =>
        this.config.paymentBeneficiaryAutocompleteEnabled && value.length >= this.config.paymentBeneficiaryAutocompleteMinLength
          ? this.beneficiariesService.getBeneficiaries(value).pipe(
              map((response) => response.results),
              catchError((error: unknown) => {
                this.errorService.handleRequestError(error);
                return of([] as PartyBeneficiary[]);
              })
            )
          : of([] as PartyBeneficiary[])
      ),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  onBeneficiaryNameInput(event: Event): void {
    const value = (event.target as HTMLInputElement | null)?.value ?? '';
    this.beneficiaryNameInput$.next(value);
  }

  onBeneficiaryAutocompleteSelectionChange(event: NzOptionSelectionChange, beneficiary: PartyBeneficiary): void {
    if (event.isUserInput) {
      this.selectedBeneficiary = beneficiary;
      this.beneficiarySelected.emit(beneficiary);
    }
  }
}
